export default __webpack_public_path__ + "static/media/SimbaVideo.2360910c.mp4";